export default __webpack_public_path__ + "static/vector-shape2-2d97c90b554c9fcfde30168f44a61154.png";